import 'core-js/stable';
import 'regenerator-runtime/runtime';
import * as model from './model.js';
import recipeView from './views/recipeView.js';
import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import paginationView from './views/paginationView.js';
import bookmarksView from './views/bookmarksView.js';
import addRecipeView from './views/addRecipeView.js';
import { UPLOAD_OVERLAY_TIMEOUT } from './config.js';

init();

async function controlRecipe() {
  try {
    const id = window.location.hash.slice(1);
    if (!id) return;

    // Render Spinner
    recipeView.renderSpinner();

    // Update results view to mark selected search results
    resultsView.update(model.getSearchResultsOfPage());
    bookmarksView.update(model.state.bookmarks);

    // Wait for recipe fetch
    await model.getRecipe();

    // Render recipe
    recipeView.render(model.state.recipe);
  } catch (err) {
    console.error(err); // Remove later
    recipeView.renderError();
  }
}

async function controlSearchResults() {
  try {
    // Reset
    resultsView._clear();

    // Check if something has been entered
    const query = searchView.getQuery();
    if (!query) {
      resultsView.renderError();
      return;
    }

    // Render Results
    model.resetPage();
    await model.getSearchResults(query);

    // Check if we got a result
    if (model.state.search.results.length === 0) {
      resultsView.renderError();
      return;
    }

    // Render results of page 1
    resultsView.render(model.getSearchResultsOfPage());
    paginationView.render(model.state.search);

    // Create pagination
  } catch (err) {
    console.error(err);
    resultsView.renderError(err.message);
  }
}

function controlBookmarks() {
  model.state.recipe.bookmarked ? model.removeBookmark(model.state.recipe.id) : model.addBookmark(model.state.recipe);
  bookmarksView.render(model.state.bookmarks);

  if (model.state.bookmarks.length === 0) bookmarksView.renderMessage();
  recipeView.update(model.state.recipe);
}

function controlRenderBookmarks() {
  bookmarksView.render(model.state.bookmarks);
}

function controlPages(goToPage) {
  resultsView.render(model.getSearchResultsOfPage(goToPage));
  paginationView.render(model.state.search);
}

function controlServings(newServings) {
  model.updateServings(newServings);
  recipeView.update(model.state.recipe);
}

async function controlUploadRecipe(newRecipe) {
  try {
    addRecipeView.renderSpinner();

    const uploadData = await model.uploadRecipe(newRecipe);
    model.state.recipe = uploadData;

    // Render Uploaded Recipe
    recipeView.render(model.state.recipe);
    model.addBookmark(model.state.recipe);
    bookmarksView.render(model.state.bookmarks);

    // Change ID in the URL
    window.history.pushState(null, '', `#${model.state.recipe.id}`);

    addRecipeView.renderMessage();

    // Hide Overlay after timeout
    setTimeout(function () {
      addRecipeView.toggleOverlay();
    }, UPLOAD_OVERLAY_TIMEOUT * 1000);
  } catch (err) {
    console.error(err.message);
    addRecipeView.renderError(err.message);
  }
}

function init() {
  bookmarksView.addHandleRender(controlRenderBookmarks);
  recipeView.addHandlerRender(controlRecipe);
  recipeView.addHandlerServings(controlServings);
  recipeView.addHandlerBookmark(controlBookmarks);
  searchView.addHandlerSearch(controlSearchResults);
  paginationView.addHandlerPagination(controlPages);
  addRecipeView.addHandlerUpload(controlUploadRecipe);
}
